import { useContext, useEffect, useState } from 'react';
import { Grid, makeStyles, Typography, Switch, Box, CircularProgress } from '@material-ui/core';
import NameDataSpaceInput from './NameDataSpaceInput';
import SelectFantasyLeague from './SelectFantasyLeague';
import SelectSportsLeague from './SelectSportsLeague';
import NextButton from './NextButton';
import NewDataSpacePageContentWrapper from '../ui_components/NewDataSpacePageContentWrapper';
import { UserProfileContext } from '../../../../UserProfileContext';
import { trackEvent } from '../../../../utils/eventTracking';
import { getDataSpaces } from '../../../../api_helper/api';
import EditDataSpaceFormContext from '../../context/EditDataSpaceFormContext';

const useStyles = makeStyles((theme) => ({
	nameInputWrapper: {
		marginBottom: '2rem',
	},
	leagueSelectButton: {
		'& .p-button.p-highlight': {
			backgroundColor: '#EE9D34 !important',
			borderColor: '#EE9D34 !important',
		},
		'& .p-button:focus': {
			boxShadow: '0 0 0 0.2rem #ffb759',
		},
	},
	stepIconGrid: {
		marginRight: '0.8rem',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		borderRight: '3px solid #D5D5D5',
	},
	stepIcon: {
		height: '100%',
		fontSize: '2.5rem',
		color: '#D5D5D5',
	},
	orIcon: {
		fontSize: '4.5rem',
	},
	sportsLeagueSelectImage: {
		maxWidth: '25%',
		maxHeight: '100%',
		'&:hover': {
			borderRadius: '5px',
			boxShadow: 'inset 0 0 0 1px #000',
		},
	},
}));

const ConfigureDataSpace = () => {
	const classes = useStyles();

	const editDataSpaceFormContext = useContext(EditDataSpaceFormContext);
	const userProfile = useContext(UserProfileContext)[0];

	const leagueToggleChangeHandler = (e) => {
		editDataSpaceFormContext.setIsFantasyLeagueToggleChecked((prevState) => !prevState);
	};

	// Fetch the DataSpace
	useEffect(() => {
		const fetchDataSpace = async () => {
			const dataSpace = (await getDataSpaces(editDataSpaceFormContext.dataSpace._id)).data.dataSpace;

			const fantasyLeagueDataset = dataSpace.datasets.find((dataset) =>
				['Yahoo! Fantasy Sports', 'Fantrax'].includes(dataset.tags.api),
			);

			const selectedSport = fantasyLeagueDataset
				? null
				: dataSpace.datasets.find((dataset) => dataset.tags.sport).tags.sport;

			editDataSpaceFormContext.setDataSpace(dataSpace);
			editDataSpaceFormContext.setSelectedSport(selectedSport);
			editDataSpaceFormContext.setIsFantasyLeagueToggleChecked(Boolean(fantasyLeagueDataset));
			editDataSpaceFormContext.setDatasets([]);
		};
		if (!('name' in editDataSpaceFormContext.dataSpace)) {
			fetchDataSpace();
		}
	}, [editDataSpaceFormContext.dataSpace._id]);

	useEffect(() => {
		trackEvent({
			userDetails: { userId: userProfile._id, email: userProfile.email },
			eventDetails: {
				types: ['KissMetrics', 'AppInsights', 'Segment', 'GA4'],
				eventName: 'WebApp_User Visits Configure DataSpace Page In Edit DataSpace Form',
			},
		});
	}, []);

	return !editDataSpaceFormContext.dataSpace.name ? (
		<NewDataSpacePageContentWrapper header={'Edit DataSpace Name and Sport'}>
			<Box
				sx={{
					width: '100%',
					height: '10rem',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
				}}
			>
				<CircularProgress color="secondary" />
			</Box>
		</NewDataSpacePageContentWrapper>
	) : (
		<NewDataSpacePageContentWrapper header={'Edit DataSpace Name and Sport'}>
			<Grid item container xs={12} className={classes.nameInputWrapper} justifyContent="start">
				<Grid item container xs sm={9} md={5}>
					<NameDataSpaceInput />
				</Grid>
			</Grid>

			<Grid item container xs={12} justifyContent="start" style={{ marginBottom: '1rem' }}>
				<SelectSportsLeague isFantasyLeagueToggleChecked={editDataSpaceFormContext.isFantasyLeagueToggleChecked} />
			</Grid>

			<Grid item container xs={12} alignItems={'center'} style={{ marginBottom: '1rem' }}>
				<Typography variant="h8" align="left">
					Use Fantasy League
				</Typography>
				<Switch checked={editDataSpaceFormContext.isFantasyLeagueToggleChecked} onChange={leagueToggleChangeHandler} />
			</Grid>

			<SelectFantasyLeague
				style={{ display: editDataSpaceFormContext.isFantasyLeagueToggleChecked ? 'block' : 'none' }}
			/>

			<Grid item container xs={12} display="flex" justifyContent="end">
				<NextButton />
			</Grid>
		</NewDataSpacePageContentWrapper>
	);
};

export default ConfigureDataSpace;
